/* ============================================
   main.js — Tokyo Otaku Mode Shopify EC構築・運用代行 LP
   バニラJS・依存なし（defer読み込み前提）
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  /* ------------------------------------------
     1. ヘッダー：スクロールで shadow を付与
  ------------------------------------------ */
  const header = document.querySelector('.js-header');
  if (header) {
    const toggleScrolled = () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    };
    toggleScrolled();
    window.addEventListener('scroll', toggleScrolled, { passive: true });
  }

  /* ------------------------------------------
     2. ハンバーガーメニュー（フルスクリーンオーバーレイ）
  ------------------------------------------ */
  const navToggle = document.querySelector('.js-nav-toggle');
  const nav = document.querySelector('.js-nav');

  function closeNav() {
    if (!navToggle || !nav) return;
    nav.classList.remove('open');
    if (header) header.classList.remove('nav-open');
    navToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function openNav() {
    if (!navToggle || !nav) return;
    nav.classList.add('open');
    if (header) header.classList.add('nav-open'); // 展開中はヘッダーの白帯を消す
    navToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  if (navToggle && nav) {
    navToggle.addEventListener('click', () => {
      const isOpen = nav.classList.contains('open');
      if (isOpen) {
        closeNav();
      } else {
        openNav();
      }
    });

    // ナビ内のリンクをクリックしたら閉じる
    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeNav);
    });
  }

  /* ------------------------------------------
     3. FAQアコーディオン
  ------------------------------------------ */
  const faqToggles = document.querySelectorAll('.js-faq-toggle');
  faqToggles.forEach((btn) => {
    const item = btn.closest('.faq-item');
    const answer = item ? item.querySelector('.faq-item__a') : null;
    if (!item || !answer) return;

    btn.addEventListener('click', () => {
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        btn.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = null;
      } else {
        btn.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* ------------------------------------------
     4. スクロールフェードイン（IntersectionObserver）
  ------------------------------------------ */
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fadeTargets = document.querySelectorAll('.fade-in');

  if (prefersReducedMotion) {
    fadeTargets.forEach((el) => el.classList.add('visible'));
  } else if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
    );
    fadeTargets.forEach((el) => observer.observe(el));
  } else {
    // IntersectionObserver未対応ブラウザは即表示
    fadeTargets.forEach((el) => el.classList.add('visible'));
  }

  /* ------------------------------------------
     5. アンカーリンク
     オフセットはCSSの scroll-padding-top で対応済みのため、
     ここではモバイルナビを閉じる処理のみ行う
  ------------------------------------------ */
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', () => {
      if (nav && nav.classList.contains('open')) {
        closeNav();
      }
    });
  });
});
